import React, { useEffect, useRef, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import Footer from "../../../SharedFiles/Footer/Footer";
import SearchIcon from "@mui/icons-material/Search";
import QRCodeGenerator from "../../../SharedFiles/QRCode/qrGenerator";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { GetQrData } from "../../../APIServices/ProductionService/BackupQRcode/backupGenerateQrThunk";
import { toast, Toaster } from "react-hot-toast";
import { Navigate, useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { useQRModal } from "../../../../Context/QrContext";

const BackupQrcode = () => {
  const { t } = useTranslation();
  const { GetQrDetails, loading, error } = useSelector(
    (state) => state.GenerateBackUpQR
  );
  const dispatch = useDispatch();
  const [openQRModal, setOpenQRModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState("");
  const navigate = useNavigate();
  const [qrData, setQrData] = useState("");
  const [inProgress, setInProgress] = useState({
    GetBatchDetails: false,
  });
  const { PrintLabel } = useQRModal();

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (!GetQrDetails && !searchValue) {
      setInProgress((prev) => ({ ...prev, GetBatchDetails: true }));
      dispatch(GetQrData({ searchvalue: "" }));
    }
  }, []);
  const isLoading = () => {
    return loading.GetQrDetails;
  };

  const batchChecker = () => {
    if (inProgress.GetBatchDetails && error.GetQrDetailsError) {
      const errorss = error.GetQrDetailsError;
      const status = errorss.errorCode;
      const errormessage = errorss.errorMessage;
      setInProgress({ ...inProgress, GetBatchDetails: false });
      if (status === 404) {
        return null;
      } else {
        toast.error(errormessage);
      }
    }
  };
  useEffect(() => {
    batchChecker();
  }, [GetQrDetails, loading, error, inProgress]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setQrData("");
    setSelectedBatch("");
    setInProgress({ ...inProgress, GetBatchDetails: true });
    dispatch(GetQrData({ searchvalue: value }));
    setShowDropdown(true);
  };

  const handleSelect = (batchnumber) => {
    const selected = GetQrDetails.find(
      (item) => item.batchnumber === batchnumber
    );

    if (selected) {
      setSelectedBatch(selected);
      setQrData("");
      setSearchValue(batchnumber);
      setShowDropdown(false);
    }
  };

  const handleprint = () => {
    if (!selectedBatch && !searchValue) {
      toast.error("Please select a batch first");
    } else {
      try {
        const parsedData = JSON.parse(selectedBatch.batchdetails);      
        const normalizedData = Object.fromEntries(
          Object.entries(parsedData).map(([key, value]) => [key.toLowerCase(), value])
        );
      
        const data = {
          // PageTitle: pageTitle,
          Order_Number: normalizedData.ponumber,
          batch_Number: normalizedData.batchnumber,
          item_Code: normalizedData.itemcode,
          item_Name: normalizedData.itemname,
          Actual_Weight: normalizedData.actualwt,
          CreatedDate: normalizedData.createddate,
        };  
      //   const data = {
      //   // PageTitle: pageTitle,
      //   Order_Number: parsedData.PONumber,
      //   batch_Number: parsedData.BatchNumber,
      //   item_Code: parsedData.Itemcode,
      //   item_Name: parsedData.ItemName,
      //   Actual_Weight: parsedData.ActualWt,
      //   CreatedDate: parsedData.CreatedDate
      // }
        PrintLabel(data, null, "GRPO", "");
        // setQrData(parsedData);
        setOpenQRModal(true);
      } catch (err) {
        toast.error("Invalid batch data");
      }
    }
  };
  const handleCloseQRModal = () => {
    setOpenQRModal(false);
    setQrData("");
  };
  const handleBack = () => {
    setSearchValue("");
    setQrData("");
    navigate("/production/");
  };
  return (
    <>
      <div className="container mainDiv">
        <div className="col-12 gap-2 mb-4 d-flex align-items-center justify-content-between">
          <button onClick={handleBack} className="goBackButton">
            <BiArrowBack size={24} />
          </button>
          <p className="m-0 fw-medium mx-3">GENERATE QR</p>
        </div>

        {/* Searchable dropdown */}
        <div className="search-container position-relative d-flex align-items-center justify-content-center mx-3">
          <div className="search-bar-container position-relative">
            <input
              className="search-field"
              value={searchValue}
              onChange={handleSearchChange}
              onFocus={() => setShowDropdown(true)}
              placeholder={t("Search...")}
            />
            <SearchIcon
              className="search-icon position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />

            {showDropdown && (
              <ul
                ref={dropdownRef}
                className="dropdown-menu show w-100 mt-0"
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  fontSize: "14px",
                }}
              >
                {GetQrDetails && GetQrDetails?.length > 0 ? (
                  GetQrDetails.map((item, idx) => (
                    <li
                      key={idx}
                      className="dropdown-item "
                      style={{
                        border: "none",
                        borderBottom: "0.5px solid #8080802e",
                      }}
                      onClick={() => {
                        handleSelect(item.batchnumber);
                      }}
                    >
                      {item.batchnumber} - {item.itemname}
                    </li>
                  ))
                ) : (
                  <li className="dropdown-item text-muted text-center">
                    No data found
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-center">
          <button onClick={handleprint} className="button xs w-25 ms-3 mt-3">
            Print
          </button>
        </div>

        <QRCodeGenerator
          QRdata={qrData}
          openQRModal={openQRModal}
          handleCloseQRModal={handleCloseQRModal}
        />
      </div>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}

      <Footer />
    </>
  );
};

export default BackupQrcode;
